import { gql } from '@apollo/client';

export const GET_PROFILE_BY_ID = gql`
  query ProfileById($id: ID!, $limit: Int, $offset: Int, $date: ISO8601Date!) {
    user(id: $id) {
      id
      name
      createdAt
      address
      city
      postalCode
      about
      reviewCount
      ratingAverage
      avatarImageUrl
      toolCount
      toolsList(limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          name
          description
          primaryImageUrl
          pricePerDayCents
          ratingAverage
          reviewCount
          nextAvailableDate(date: $date)
        }
      }
    }
  }
`;
